export var DataCatalogPrivilege;
(function (DataCatalogPrivilege) {
    DataCatalogPrivilege["DATA_CATALOG_PRIVILEGE_DESCRIBE"] = "DESCRIBE";
    DataCatalogPrivilege["DATA_CATALOG_PRIVILEGE_SELECT"] = "SELECT";
    DataCatalogPrivilege["DATA_CATALOG_PRIVILEGE_MANAGE"] = "MANAGE";
    DataCatalogPrivilege["DATA_CATALOG_PRIVILEGE_TAG"] = "TAG";
})(DataCatalogPrivilege || (DataCatalogPrivilege = {}));
